<template>
  <span id="logo">
    <svg width="100%" height="100%" viewBox="0 0 166 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
        <g transform="matrix(1,0,0,1,-88.006,-2868.26)">
            <g transform="matrix(1,0,0,1,0,2850.76)">
                <g transform="matrix(0.7153,0,0,0.7153,-341.805,-129.972)">
                    <g transform="matrix(1.16334,0,0,1.16334,92.4376,67.0745)">
                        <circle cx="627.526" cy="127.87" r="8.307" style="fill:rgb(83,115,255);"/>
                    </g>
                    <g transform="matrix(5.15008,0,0,5.15008,-695.481,-1506.25)">
                        <g transform="matrix(12,0,0,12,257.517,343.36)">
                            <path d="M0.072,-0.71L0.228,-0.758L0.228,0L0.072,0L0.072,-0.71Z" style="fill:rgb(83,115,255);fill-rule:nonzero;"/>
                        </g>
                        <g transform="matrix(12,0,0,12,276.76,343.36)">
                            <path d="M0.515,-0.12L0.515,0L0.035,0L0.035,-0.094L0.309,-0.418L0.042,-0.418L0.042,-0.538L0.506,-0.538L0.506,-0.444L0.232,-0.12L0.515,-0.12Z" style="fill:rgb(83,115,255);fill-rule:nonzero;"/>
                        </g>
                        <g transform="matrix(12,0,0,12,282.815,343.36)">
                            <path d="M0.072,-0.506L0.228,-0.554L0.228,0L0.072,0L0.072,-0.506Z" style="fill:rgb(83,115,255);fill-rule:nonzero;"/>
                        </g>
                        <g transform="matrix(12,0,0,12,260.292,343.36)">
                            <path d="M0.072,-0.506L0.228,-0.554L0.228,0L0.072,0L0.072,-0.506Z" style="fill:rgb(83,115,255);fill-rule:nonzero;"/>
                        </g>
                        <g transform="matrix(0.194172,0,0,0.194172,211.834,323.589)">
                            <path d="M383.121,85.199C383.122,75.762 390.784,68.1 400.221,68.1C409.659,68.1 417.321,75.762 417.321,85.199C417.321,94.637 409.659,102.299 400.221,102.299C397.548,102.299 395.017,101.684 392.762,100.588L392.762,112.813L383.121,115.813L383.121,85.199ZM400.221,77.248C404.609,77.248 408.172,80.811 408.172,85.199C408.172,89.587 404.609,93.15 400.221,93.15C395.833,93.15 392.27,89.587 392.27,85.199C392.27,80.811 395.833,77.248 400.221,77.248Z" style="fill:rgb(83,115,255);"/>
                        </g>
                        <g transform="matrix(0.194172,0,0,0.194172,202.906,278.514)">
                            <path d="M344.601,326.051C341.622,331.08 336.141,334.456 329.877,334.456C320.439,334.456 312.777,326.794 312.777,317.356C312.777,307.918 320.439,300.256 329.877,300.256C336.141,300.256 341.622,303.632 344.601,308.661L336.332,312.717C334.888,310.712 332.534,309.405 329.877,309.405C325.488,309.405 321.926,312.968 321.926,317.356C321.926,321.744 325.488,325.307 329.877,325.307C332.534,325.307 334.888,324 336.332,321.995L344.601,326.051Z" style="fill:rgb(83,115,255);"/>
                        </g>
                        <g transform="matrix(0.194172,0,0,0.194172,190.985,278.51)">
                            <path d="M344.601,326.051C341.622,331.08 336.141,334.456 329.877,334.456C320.439,334.456 312.777,326.794 312.777,317.356C312.777,307.918 320.439,300.256 329.877,300.256C336.141,300.256 341.622,303.632 344.601,308.661L336.332,312.717C334.888,310.712 332.534,309.405 329.877,309.405C325.488,309.405 321.926,312.968 321.926,317.356C321.926,321.744 325.488,325.307 329.877,325.307C332.534,325.307 334.888,324 336.332,321.995L344.601,326.051Z" style="fill:rgb(83,115,255);"/>
                        </g>
                        <g transform="matrix(0.194172,0,0,0.194172,191.644,268.993)">
                            <path d="M414.331,361.201L426.421,349.747L437.916,349.747L424.824,362.428L437.916,382.996L426.808,382.996L417.952,369.084L414.331,372.592L414.331,382.996L404.69,382.996L404.69,340.14L414.331,337.14L414.331,361.201Z" style="fill:rgb(83,115,255);fill-rule:nonzero;"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  </span>
</template>

<script>

export default {
  name: 'Logo'
}

</script>

<style scoped>

#logo {
  height:40px;
  width: 133px;
  margin: 0 0 4px 0;
  display: block;
}
@media(min-width:360px) {
  #logo {
    height:50px;
    width: 166px;
    margin: 0 0 6px 0;
  }
}

</style>
